import * as React from 'react';
import {Query} from 'react-apollo';

import {ModalBody} from 'shells/typography/modal-body';

import type {GetPinnedDomains as GetPinnedDomainsQuery} from 'nutshell-graphql-types';

import GET_PINNED_DOMAINS from '../graphql/queries/get-pinned-domains.graphql';

import {JoinedDomains} from './joined-domains';

class GetPinnedDomains extends Query<GetPinnedDomainsQuery, Record<any, any>> {}

export function PinnedInstanceNote() {
    return (
        <GetPinnedDomains query={GET_PINNED_DOMAINS}>
            {({data, loading: isLoading}) => {
                const pinnedDomains =
                    (data && data && data.sessionInstance && data.sessionInstance.pinnedDomains) ||
                    [];

                const internalDomains =
                    (data &&
                        data &&
                        data.sessionInstance &&
                        data.sessionInstance.internalDomains) ||
                    [];

                const domains = [...pinnedDomains, ...internalDomains];

                // Avoid flashing different text while loading domains
                if (isLoading) return null;

                if (domains.length) {
                    return (
                        <ModalBody as='div'>
                            Internal emails you exchange within your company won’t be shown in
                            Nutshell. This includes anyone with an {''}
                            {/* @ts-expect-error */}
                            <JoinedDomains domains={domains} /> {''}
                            address, even if they’re not using Nutshell.
                        </ModalBody>
                    );
                }

                return (
                    <ModalBody>
                        Emails that you exchange with other Nutshell users in your company will not
                        sync into your account.
                    </ModalBody>
                );
            }}
        </GetPinnedDomains>
    );
}
